import gsap from 'gsap';

export default function initFormPlaceholder() {
  const rowArray = []
  let resizeTimer;
  document.querySelectorAll('.form-row').forEach(function(row) {
    const input = row.querySelector('input.wpcf7-form-control, textarea.wpcf7-form-control');
    const label = row.querySelector('label');

    input.addEventListener('focus', ()=> {
      gsap.to(label, {autoAlpha: 0, duration:0.2 });
    });
    input.addEventListener('blur', ()=> {
      if(!input.value) gsap.to(label, {autoAlpha: 1, duration:0.2 });
    });
    input.addEventListener('change', ()=>{
      console.log('change')
    })
    rowArray.push({
      label,
      input
    })
  });

  document.querySelectorAll('.wpcf7-form').forEach(form=> {
    const rows = Array.from(form.children).filter(
      el => !el.classList.contains('wpcf7-response-output')
    );
    
    form.addEventListener('wpcf7mailsent', (e)=> {
      console.log(e);
      gsap.to(rows, {autoAlpha: 0, duration: 0.4, onComplete: ()=>{
        setTimeout(()=>{
          form.reset();
          rowArray.forEach(obj=> {
            gsap.set(obj.label, {autoAlpha: 1 });
          });
          gsap.set(rows, {
            autoAlpha: 1,
            clearProps: 'all'
          });
        }, 3000);
      }});
    })
  });

  function setTopLeft() {
    rowArray.forEach(obj=> {
      const styles = window.getComputedStyle(obj.input);
      gsap.set(obj.label, {
        top: parseFloat(styles.getPropertyValue('padding-top')) + parseFloat(styles.getPropertyValue('border-top-width')),
        left: parseFloat(styles.getPropertyValue('padding-left')) + parseFloat(styles.getPropertyValue('border-left-width'))
      });
    });
  }
  setTopLeft();

  window.addEventListener('resize', ()=> {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(()=>{
      setTopLeft();
    }, 100)
  });
}